<template>
  <div>
    <div
      class="flex_between page_title"
      style="padding-right: 20px"
    >
      <div>积分商城设置</div>
      <span>
        <el-button
          type="primary"
          style="width:92px"
          @click="submitForm"
          :disabled="module_id_array[0] ? !module_id_array.includes('1014'): false"
        >保 存</el-button>
        <el-button
          plain
          @click="cancelSubmit"
          style="width:92px"
        >取 消</el-button>
      </span>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <el-form
          :model="info"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
        >
          <!-- <el-form-item
            label="入口状态"
            prop="status"
          >
            <el-radio
              v-model="info.status"
              :label="1"
            >开启</el-radio>
            <el-radio
              v-model="info.status"
              :label="0"
            >关闭</el-radio>
          </el-form-item> -->
          <!-- <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input-number
              v-model="info.sort"
              :min="0"
              :max="9999"
              style="width: 200px"
              :precision="0"
              :controls="false"
            ></el-input-number>
            <span style="color: #999; font-size: 12px; margin-left: 5px">
              在积分商城、限时秒杀、会员热卖展示上，排序数字越大越靠前
            </span>
          </el-form-item> -->
          <!-- <el-form-item
            label="商城入口标题图"
            prop="enter_img"
          >
            <el-upload
              name="image"
              :show-file-list="false"
              :http-request="uploadImg"
              action="enter_img"
              accept=".png,.jpeg,.jpg"
            >
              <el-button
                slot="trigger"
                type="text"
              >上传本地图片</el-button>
              <span
                style="color: #999; font-size: 12px; margin-left: 10px">支持png,jpeg,jpg格式，建议尺寸700*100px</span>
            </el-upload>
          </el-form-item> -->
          <!-- <div
            class="box"
            v-show="info.enter_img"
          >
            <img
              :src="info.enter_img_str"
              class="img"
            />
            <el-upload
              :show-file-list="false"
              :http-request="uploadImg"
              action="enter_img"
              accept=".png,.jpeg,.jpg"
            >
              <div class="shadow column-center column">
                <div>
                  <i
                    class="el-icon-search"
                    @click.stop="showImg(info.enter_img_str)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="delImg(1)"
                  ></i>
                </div>
              </div>
            </el-upload>
          </div> -->
          <el-form-item
            label="分享海报图"
            prop="share_poster"
          >
            <el-upload
              name="image"
              :show-file-list="false"
              :http-request="uploadImg"
              action="share_poster"
              accept=".png,.jpeg,.jpg"
            >
              <el-button
                slot="trigger"
                type="text"
              >上传本地图片</el-button>
              <span
                style="color: #999; font-size: 12px; margin-left: 10px">支持png,jpeg,jpg格式，建议尺寸700*100px</span>
            </el-upload>
          </el-form-item>
          <div
            class="box"
            v-show="info.share_poster"
          >
            <img
              :src="info.share_poster_str"
              class="img"
            />
            <el-upload
              :show-file-list="false"
              :http-request="uploadImg"
              action="share_poster"
              accept=".png,.jpeg,.jpg"
            >
              <div class="shadow column-center column">
                <div>
                  <i
                    class="el-icon-search"
                    @click.stop="showImg(info.share_poster_str)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="delImg(4)"
                  ></i>
                </div>
              </div>
            </el-upload>
          </div>
          <el-form-item label="分享卡片图">
            <el-upload
              name="image"
              :show-file-list="false"
              :http-request="uploadImg"
              action="share_img"
              accept=".png,.jpeg,.jpg"
            >
              <el-button
                slot="trigger"
                type="text"
              >上传本地图片</el-button>
              <span
                style="color: #999; font-size: 12px; margin-left: 10px">支持png,jpeg,jpg格式，建议尺寸700*100px</span>
            </el-upload>
          </el-form-item>
          <div
            class="box"
            v-show="info.share_img"
          >
            <img
              :src="info.share_img_str"
              class="img"
            />
            <el-upload
              :show-file-list="false"
              :http-request="uploadImg"
              action="share_img"
              accept=".png,.jpeg,.jpg"
            >
              <div class="shadow column-center column">
                <div>
                  <i
                    class="el-icon-search"
                    @click.stop="showImg(info.share_img_str)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="delImg(5)"
                  ></i>
                </div>
              </div>
            </el-upload>
          </div>
          <el-form-item
            label="入口背景图"
            prop="enter_bg_image"
          >
            <el-upload
              name="image"
              :show-file-list="false"
              :http-request="uploadImg"
              action="enter_bg_image"
              accept=".png,.jpeg,.jpg"
            >
              <el-button
                slot="trigger"
                type="text"
              >上传本地图片</el-button>
              <span
                style="color: #999; font-size: 12px; margin-left: 10px">首页商城入口商品模块的外边框背景图，支持png,jpeg,jpg格式，建议尺寸700*312px</span>
            </el-upload>
          </el-form-item>
          <div
            class="box"
            v-show="info.enter_bg_image"
          >
            <img
              :src="info.enter_bg_image_str"
              class="img"
            />
            <el-upload
              :show-file-list="false"
              :http-request="uploadImg"
              action="enter_bg_image"
              accept=".png,.jpeg,.jpg"
            >
              <div class="shadow column-center column">
                <div>
                  <i
                    class="el-icon-search"
                    @click.stop="showImg(info.enter_bg_image_str)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="delImg(2)"
                  ></i>
                </div>
              </div>
            </el-upload>
          </div>
          <el-form-item
            label="详情页banner"
            prop="banner_img"
          >
            <el-upload
              name="image"
              :show-file-list="false"
              :http-request="uploadImg"
              action="banner_img"
              accept=".png,.jpeg,.jpg"
            >
              <el-button
                slot="trigger"
                type="text"
              >上传本地图片</el-button>

              <span
                style="color: #999; font-size: 12px; margin-left: 10px">高度750px，底部必须预留18px空白区域，支持png,jpeg,jpg格式</span>
            </el-upload>
          </el-form-item>
          <div
            class="box"
            v-show="info.banner_img"
          >
            <img
              :src="info.banner_img_str"
              class="img"
            />
            <el-upload
              :show-file-list="false"
              :http-request="uploadImg"
              action="banner_img"
              accept=".png,.jpeg,.jpg"
            >
              <div class="shadow column-center column">
                <div>
                  <i
                    class="el-icon-search"
                    @click.stop="showImg(info.banner_img_str)"
                  ></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="delImg(3)"
                  ></i>
                </div>
              </div>
            </el-upload>
          </div>
          <el-form-item
            label="详情背景色1"
            prop="info_bg_color_one"
          >
            <el-input
              v-model="info.info_bg_color_one"
              style="width: 280px"
              placeholder="请输入颜色值"
            ></el-input>
            <span style="color: #999; font-size: 12px; margin-left: 10px">兑换商城详情页商品列表背景</span>
          </el-form-item>
          <el-form-item
            label="详情背景色2"
            prop="info_bg_color_two"
          >
            <el-input
              v-model="info.info_bg_color_two"
              style="width: 280px"
              placeholder="请输入颜色值"
            ></el-input>
            <span style="color: #999; font-size: 12px; margin-left: 10px">兑换商城详情页商品列表背景</span>
          </el-form-item>
          <el-form-item
            label="活动分享"
            prop="is_share"
            required=""
          >
            <el-radio
              v-model="info.is_share"
              :label="1"
            >可分享</el-radio>
            <el-radio
              v-model="info.is_share"
              :label="0"
            >不支持分享</el-radio>
          </el-form-item>
          <!-- 商品列表 -->
          <div class="title flex between">
            <span>
              <span style="color: #e0372d">*</span>
              商品列表
              <el-button
                style="margin-left: 20px"
                type="primary"
                @click="chooseGoodShow = true"
              >选择商品</el-button>
            </span>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="info.goods_list"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                label="商品"
                width="320"
              >
                <template slot-scope="scope">
                  <div
                    class="flex between"
                    style="width: 300px"
                  >
                    <el-image
                      :src="scope.row.picture_str"
                      :preview-src-list="[scope.row.picture_str]"
                      style="width: 100px; height: 100px"
                    />
                    <div style="width: 180px">
                      <div>{{ scope.row.goods_name }}</div>
                      <div style="color:#EA6528">¥ {{scope.row.price}}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="integral_price"
                label="可积分兑换金额"
              />
              <el-table-column
                prop="stock"
                label="库存"
              />
              <el-table-column label="入口图">
                <template slot-scope="scope">
                  <div
                    class="table_img"
                    v-if="scope.row.enter_img_str"
                  >
                    <img
                      :src="scope.row.enter_img_str"
                      class="img"
                    />
                    <div class="shadow column-center column">
                      <div>
                        <i
                          class="el-icon-search"
                          @click.stop="showImg(scope.row.enter_img_str)"
                        ></i>
                        <i
                          class="el-icon-delete"
                          @click.stop="delGoodsImg(scope.row,1)"
                        ></i>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="置顶广告图">
                <template slot-scope="scope">
                  <div
                    class="table_img"
                    v-if="scope.row.poster_img_str"
                  >
                    <img
                      :src="scope.row.poster_img_str"
                      class="img"
                    />
                    <div class="shadow column-center column">
                      <div>
                        <i
                          class="el-icon-search"
                          @click.stop="showImg(scope.row.poster_img_str)"
                        ></i>
                        <i
                          class="el-icon-delete"
                          @click.stop="delGoodsImg(scope.row,2)"
                        ></i>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="排序">
                <template slot-scope="scope">
                  <el-button
                    style="font-size:24px"
                    type="text"
                    icon="el-icon-top"
                    v-if="info.goods_list.length>1&&scope.$index>0"
                    @click="changeSort(scope.$index,1)"
                  ></el-button>
                  <el-button
                    style="font-size:24px"
                    type="text"
                    icon="el-icon-bottom"
                    v-if="info.goods_list.length>1&&scope.$index!=info.goods_list.length-1"
                    @click="changeSort(scope.$index,2)"
                  ></el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="300"
              >
                <template slot-scope="scope">
                  <div class="flex">
                    <el-button
                      type="text"
                      @click="delGoods(scope.$index)"
                    >删除</el-button>
                    <el-upload
                      style="margin-left:10px"
                      name="image"
                      accept=".png,.jpeg,.jpg"
                      :show-file-list="false"
                      v-show="!scope.row.enter_img_str"
                      :http-request="
                        (params) => {
                          uploadImg(params, scope.row,scope.$index);
                        }
                      "
                      action="enter_img_table"
                    >
                      <el-button type="text">设置入口图</el-button>
                    </el-upload>
                    <el-upload
                      name="image"
                      accept=".png,.jpeg,.jpg"
                      :show-file-list="false"
                      v-show="!scope.row.is_top"
                      style="margin-left:10px"
                      :http-request="
                        (params) => {
                          uploadImg(params, scope.row,scope.$index);
                        }
                      "
                      action="poster_img"
                    >
                      <el-button type="text">设置置顶广告</el-button>
                    </el-upload>
                    <el-button
                      style="margin-left:10px"
                      type="text"
                      v-show="scope.row.enter_img_str"
                      @click="cancelEnter(scope.row)"
                    >取消入口图</el-button>
                    <el-button
                      type="text"
                      v-show="scope.row.is_top"
                      @click="cancelTop(scope.row)"
                    >取消置顶广告</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />
    <!-- 选择活动商品 -->
    <ChooseGood
      :act_id="info.act_id || 0"
      v-if="chooseGoodShow"
      @close="chooseGoodShow = false"
      @checkGoods="checkGoods"
    ></ChooseGood>
  </div>
</template>
<script>
import { uploadImg } from '../../../service/common/constant';
import ChooseGood from './ChooseGood';
export default {
  data() {
    return {
      page_title: '新增活动',
      act_id: false,
      info: {
        enter_bg_image: '',
        enter_bg_image_str: '',
        enter_img: '',
        enter_img_str: '',
        banner_img: '',
        banner_img_str: '',
        share_poster: '',
        share_poster_str: '',
        share_img: '',
        share_img_str: '',
        info_bg_color_one: '',
        info_bg_color_two: '',
        is_share: 1,
        goods_list: []
      },
      rules: {
        status: [
          { required: true, message: '请选择活动状态', trigger: 'blur' }
        ],
        sort: [{ required: true, message: '请输入排序值', trigger: 'blur' }],
        enter_img: [
          { required: true, message: '请上传商城入口标题图', trigger: 'blur' }
        ],
        share_poster: [
          { required: true, message: '请上传分享海报图', trigger: 'blur' }
        ],
        banner_img: [
          { required: true, message: '请上传详情banner', trigger: 'blur' }
        ],
        enter_bg_image: [
          { required: true, message: '请上传入口背景图', trigger: 'blur' }
        ],
        goods_list: [
          { required: true, message: '请选择活动商品', trigger: 'blur' }
        ],
        info_bg_color_one: [
          { required: true, message: '请输入详情背景颜色值', trigger: 'blur' }
        ],
        info_bg_color_two: [
          { required: true, message: '请输入详情背景颜色值', trigger: 'blur' }
        ]
      },
      imgList: [],
      showViewer: false,
      chooseGoodShow: false
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  components: {
    'el-image-viewer': () =>
      import('element-ui/packages/image/src/image-viewer'),
    ChooseGood
  },
  created() {
    this.getInfo();
  },
  methods: {
    //获取详情
    getInfo() {
      this.axios.post('platform/shop/getShopIntegralActivity').then((res) => {
        this.info = res.data.info;
      });
    },
    //上传图片
    uploadImg(params, item, index) {
      let file = params.file;
      uploadImg(file)
        .then((res) => {
          if (params.action == 'enter_img') {
            this.info.enter_img = res.data.pic;
            this.info.enter_img_str = res.data.path;
          } else if (params.action == 'enter_bg_image') {
            this.info.enter_bg_image = res.data.pic;
            this.info.enter_bg_image_str = res.data.path;
          } else if (params.action == 'share_poster') {
            this.info.share_poster = res.data.pic;
            this.info.share_poster_str = res.data.path;
          } else if (params.action == 'share_img') {
            this.info.share_img = res.data.pic;
            this.info.share_img_str = res.data.path;
          } else if (params.action == 'banner_img') {
            this.info.banner_img = res.data.pic;
            this.info.banner_img_str = res.data.path;
          } else if (params.action == 'poster_img') {
            this.$set(this.info.goods_list[index], 'is_top', 1);
            this.$set(this.info.goods_list[index], 'poster_img', res.data.pic);
            this.$set(
              this.info.goods_list[index],
              'poster_img_str',
              res.data.path
            );
            this.$forceUpdate();
          } else if (params.action == 'enter_img_table') {
            this.$set(this.info.goods_list[index], 'enter_img', res.data.pic);
            this.$set(
              this.info.goods_list[index],
              'enter_img_str',
              res.data.path
            );
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //查看图片
    showImg(item) {
      this.imgList = [item];
      this.showViewer = true;
    },
    //删除图片
    delImg(type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          if (type == 1) {
            this.info.enter_img = '';
            this.info.enter_img_str = '';
          } else if (type == 2) {
            this.info.enter_bg_image = '';
            this.info.enter_bg_image_str = '';
          } else if (type == 3) {
            this.info.banner_img = '';
            this.info.banner_img_str = '';
          } else if (type == 4) {
            this.info.share_poster = '';
            this.info.share_poster_str = '';
          } else if (type == 5) {
            this.info.share_img = '';
            this.info.share_img_str = '';
          }
        })
        .catch(() => {});
    },
    //选择商品
    checkGoods(goods) {
      let list = [];
      goods.map((item) => {
        if (item.open_spec == 1) {
          item.sku_list.map((i) => {
            let data = {
              goods_id: item.goods_id,
              goods_name: item.goods_name,
              picture_str: item.picture,
              integral_price: item.integral_price,
              stock: i.stock,
              price: i.price,
              is_top: 0
            };
            list.push(data);
          });
        } else {
          item.picture_str = item.picture;
          item.sku_id = 0;
          item.is_top = 0;
          list.push(item);
        }
      });
      list.forEach((ele1) => {
        let index = this.info.goods_list.findIndex((ele2) => {
          if (ele1.sku_id) {
            return ele2.sku_id == ele1.sku_id;
          } else {
            return ele2.goods_id == ele1.goods_id;
          }
        });
        if (index == -1) {
          this.info.goods_list.push(ele1);
        }
      });
      this.chooseGoodShow = false;
    },
    //取消置顶
    cancelTop(item) {
      this.$confirm('您确定要取消吗？取消后图片同时被删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          item.poster_img = '';
          item.poster_img_str = '';
          item.is_top = 0;
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    //取消入口图
    cancelEnter(item) {
      this.$confirm('您确定要取消吗？取消后图片同时被删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          item.enter_img = '';
          item.enter_img_str = '';
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    //删除商品图
    delGoodsImg(row, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          if (type == 1) {
            row.enter_img = '';
            row.enter_img_str = '';
          } else if (type == 2) {
            row.poster_img = '';
            row.poster_img_str = '';
          }
        })
        .catch(() => {});
    },
    //删除商品
    delGoods(index) {
      this.info.goods_list.splice(index, 1);
    },
    //排序的修改
    changeSort(index, sort) {
      let data = this.info.goods_list[index];
      this.info.goods_list.splice(index, 1);
      //上移
      if (sort == 1) {
        this.info.goods_list.splice(index - 1, 0, data);
      }
      //下移
      if (sort == 2) {
        this.info.goods_list.splice(index + 1, 0, data);
      }
    },
    //取消编辑
    cancelSubmit() {
      this.$confirm('确定放弃编辑内容吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.getInfo();
        })
        .catch(() => {});
    },

    //提交添加
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.info.status == 1 && !this.info.goods_list.length) {
            this.$message.error('请选择参与活动的商品');
            return false;
          }
          this.info.goods_list.forEach((item, index) => {
            item.sort = index;
            if (item.poster_img) {
              item.is_top = 1;
            } else {
              item.is_top = 0;
            }
          });
          let data = this.info;
          this.axios
            .post('platform/shop/saveShopIntegralActivity', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('保存成功');
                this.getInfo();
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;
}

.box {
  margin-top: -20px;
  position: relative;
  padding-left: 120px;
  box-sizing: border-box;
  &:hover .shadow {
    display: flex;
  }
  .img {
    width: 200px;
    height: 200px;
  }
  .shadow {
    box-sizing: border-box;
    position: absolute;
    left: 120px;
    top: 0;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
  }
  i + i {
    margin-left: 30px;
    color: #d44747;
  }
  i {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }
}
.table_img {
  position: relative;
  box-sizing: border-box;
  &:hover .shadow {
    display: flex;
  }
  .img {
    width: 120px;
    height: 120px;
  }
  .shadow {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    width: 120px;
    height: 120px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
  }
  i + i {
    margin-left: 30px;
    color: #d44747;
  }
  i {
    color: #ffffff;
    font-size: 24px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: 100px;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
</style>